import { z } from "zod";

export type QcBizGuest = z.infer<typeof QcBizGuestSchema>;
export const QcBizGuestSchema = z.object({
  id: z.number().nullable(),
  code: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  location_id: z.number().nullable(),
  phone_number: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  state: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  available_from: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  available_to: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  conversation_id: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  qr: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  qr_with_lang: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  lang_cd: z
    .string()
    .nullable()
    .transform((value) => value ?? "en"),
  receive_notice: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  tenant_id: z.number().optional(),
  // room_name: QcBizLocationSchema,
  room_name: z.object({ name: z.string() }),
});
